export const chickFilAFridayAttendance = [
  {
    employeeSlug: 'marcus-gunn', passportSlug: 'marcus-g', employeeName: 'Marcus', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 81, attendancePercentage: 86.2, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'alfred-miller', passportSlug: 'al-m', employeeName: 'Al', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 84, attendancePercentage: 89.4, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'benjamin-brandt', passportSlug: 'ben-b', employeeName: 'Ben', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 85, attendancePercentage: 90.4, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'brandon-armstrong', passportSlug: 'brandon-a', employeeName: 'Brandon A.', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 81, attendancePercentage: 86.2, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'jasmine-barnes', passportSlug: 'jasmine-b', employeeName: 'Jasmine', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 71, attendancePercentage: 75.5, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'bradford-beacham', passportSlug: 'brad-b', employeeName: 'Brad', eligibilityStartDate: '2024-09-13', eligibilityEndDate: '2026-01-23', eligibleEvents: 64, attendedEvents: 51, attendancePercentage: 79.7, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'kevin-louie', passportSlug: 'kevin-l', employeeName: 'Kevin', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 75, attendancePercentage: 79.8, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'phillip-hetzler', passportSlug: 'phillip-h', employeeName: 'Phillip', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 55, attendancePercentage: 58.5, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'andrea-fields', employeeName: 'Andrea', eligibilityStartDate: '2026-06-23', eligibilityEndDate: null, eligibleEvents: 13, attendedEvents: 10, attendancePercentage: 76.9, attendanceSource: 'timesheet',
  },
  {
    employeeSlug: 'brandon-lea', passportSlug: 'brandon-l', employeeName: 'Brandon L.', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 18, attendancePercentage: 19.1, attendanceSource: 'manual-override',
  },
  {
    employeeSlug: 'matt-g', passportSlug: 'matt-g', employeeName: 'Matt', eligibilityStartDate: '2024-09-13', eligibilityEndDate: null, eligibleEvents: 94, attendedEvents: 0, attendancePercentage: 0, attendanceSource: 'manual-override',
  },
  {
    employeeSlug: 'arthur-greenberg', employeeName: 'Arthur', eligibilityStartDate: '2026-06-29', eligibilityEndDate: null, eligibleEvents: 12, attendedEvents: 9, attendancePercentage: 75, attendanceSource: 'timesheet',
  },
];

export default chickFilAFridayAttendance;
